export default __webpack_public_path__ + "static/media/img-0359-central-african-half-face.49a3655c.png";